import React from "react";

import { LineInput } from "components/Inputs/LineInput";

import styles from "./style.module.css";

const RealityCheckCard = (props) => {
  const {
    setup,
    modelGroups,
    updatePursuedCount,
    updateNotPursuedCount,
    updatePursuedRatio,
    updateNotPursuedRatio,
    resetBudget,
    id,
    applyOverall,
    runId
  } = props;

  const trueAction = setup.trueAction ? setup.trueAction : "Pursue";
  const falseAction = setup.falseAction ? setup.falseAction : "Ignore";

  const transactionLabel = setup.transactionLabel ? setup.transactionLabel : "Opportunities";

  const notPursuedTransactionLabel = setup.notPursuedTransactionLabel
    ? setup.notPursuedTransactionLabel
    : "Potential " + transactionLabel;

  const outcomeLabel =
    setup.outcomeLabel == undefined
      ? setup.success && setup.success.label !== undefined
        ? setup.success.label
        : setup.truePositiveLabel
      : setup.outcomeLabel;

  const modelGroupSegments =
    modelGroups && modelGroups.drilldownValues && modelGroups.drilldownValues.length > 1
      ? modelGroups.drilldownValues.filter((model) => model.column !== "Overall")
      : modelGroups.drilldownValues[0];

  const hasSplits =
    modelGroups &&
    modelGroups.drilldownValues &&
    modelGroups.drilldownValues.filter((group) => group.label !== "Overall").length > 0;

  const realityColumn = (model) => {
    const runId = model && model.runId;
    const setup = model && model.setup ? model.setup : setup;

    const truePositive =
      setup.isRealityHammer && setup.baselineCounts
        ? Number(setup.baselineCounts.truePositive)
        : Number(setup.truePositive);
    const falsePositive =
      setup.isRealityHammer && setup.baselineCounts
        ? Number(setup.baselineCounts.falsePositive)
        : Number(setup.falsePositive);
    const trueNegative =
      setup.isRealityHammer && setup.baselineCounts
        ? Number(setup.baselineCounts.trueNegative)
        : Number(setup.trueNegative);
    const falseNegative =
      setup.isRealityHammer && setup.baselineCounts
        ? Number(setup.baselineCounts.falseNegative)
        : Number(setup.falseNegative);

    const pursued = truePositive + falsePositive;
    const notPursued = trueNegative + falseNegative;

    const winRate =
      truePositive + falsePositive === 0 ? 0 : ((truePositive / (truePositive + falsePositive)) * 100).toFixed(2);

    const notPursusedWinRate =
      falseNegative + trueNegative === 0 ? 0 : ((falseNegative / (falseNegative + trueNegative)) * 100).toFixed(2);

    return (
      <div className={styles.realityColumn}>
        {hasSplits ? (
          <div
            className={styles.realityColumnHeader}
            style={{
              backgroundColor: model.color,
              color: model.label === "Overall" ? "#FFFF" : "black"
            }}
          >
            {model.label}
          </div>
        ) : (
          <div className={styles.realityColumnHeader} style={{ minHeight: "0px" }}></div>
        )}

        <React.Fragment>
          <div className={styles.realityInputSection}>
            <LineInput
              isMediumBox
              labelStyle={{ color: "#4B495B" }}
              value={pursued}
              onChange={(val) => updatePursuedCount(runId, val.replace(/,/g, ""))}
              isDisabled={applyOverall}
            />
          </div>
          <div className={styles.realityInputSection}>
            <LineInput
              isMediumBox
              labelStyle={{ color: "#4B495B" }}
              value={winRate}
              onChange={(val) => updatePursuedRatio(runId, val)}
              isDisabled={applyOverall}
            />
          </div>
          <div className={styles.realityInputSection}>
            <LineInput
              isMediumBox
              labelStyle={{ color: "#4B495B" }}
              value={notPursued}
              onChange={(val) => updateNotPursuedCount(runId, val.replace(/,/g, ""))}
              isDisabled={applyOverall}
            />
          </div>
          <div className={styles.realityInputSection}>
            <LineInput
              isMediumBox
              labelStyle={{ color: "#4B495B" }}
              value={notPursusedWinRate}
              onChange={(val) => updateNotPursuedRatio(runId, val)}
              isDisabled={applyOverall}
            />
          </div>
        </React.Fragment>
      </div>
    );
  };

  const renderRealityCheckColumns = () => {
    if (modelGroupSegments && modelGroupSegments.length > 0) {
      const models = modelGroupSegments.map((model) => {
        return <React.Fragment key={model.runId}>{realityColumn(model)}</React.Fragment>;
      });
      return models;
    } else if (modelGroupSegments.runId) {
      return realityColumn(modelGroupSegments);
    }
    return null;
  };

  const renderOverallControlColumn = () => {
    if (modelGroupSegments && modelGroupSegments.label === "Overall") {
      return null;
    }
    const truePositive = modelGroupSegments
      .map((model) => {
        const setup = model.setup;
        return setup.isRealityHammer && setup.baselineCounts
          ? Number(setup.baselineCounts.truePositive)
          : Number(setup.truePositive);
      })
      .reduce((a, b) => a + b, 0);
    const falsePositive = modelGroupSegments
      .map((model) => {
        const setup = model.setup;
        return setup.isRealityHammer && setup.baselineCounts
          ? Number(setup.baselineCounts.falsePositive)
          : Number(setup.falsePositive);
      })
      .reduce((a, b) => a + b, 0);
    const trueNegative = modelGroupSegments
      .map((model) => {
        const setup = model.setup;
        return setup.isRealityHammer && setup.baselineCounts
          ? Number(setup.baselineCounts.trueNegative)
          : Number(setup.trueNegative);
      })
      .reduce((a, b) => a + b, 0);
    const falseNegative = modelGroupSegments
      .map((model) => {
        const setup = model.setup;
        return setup.isRealityHammer && setup.baselineCounts
          ? Number(setup.baselineCounts.falseNegative)
          : Number(setup.falseNegative);
      })
      .reduce((a, b) => a + b, 0);

    const pursued = truePositive + falsePositive;
    const notPursued = trueNegative + falseNegative;

    const winRate =
      truePositive + falsePositive === 0 ? 0 : ((truePositive / (truePositive + falsePositive)) * 100).toFixed(2);

    const notPursusedWinRate =
      falseNegative + trueNegative === 0 ? 0 : ((falseNegative / (falseNegative + trueNegative)) * 100).toFixed(2);

    const segments =
      modelGroups &&
      modelGroups.drilldownValues &&
      modelGroups.drilldownValues.filter((model) => model.column !== "Overall");

    const numSegments = segments.length;

    const updateAllPursuedCount = (val) => {
      for (let i = 0; i < segments.length; i++) {
        updatePursuedCount(segments[i].runId, Math.round(Number(val.replace(/,/g, "")) / numSegments), true);
      }
      resetBudget(id);
    };

    const updateAllPursuedRatio = (val) => {
      console.log(val);
      for (let i = 0; i < segments.length; i++) {
        updatePursuedRatio(segments[i].runId, val, true);
      }
      resetBudget(id);
    };

    const updateAllNotPursuedCount = (val) => {
      for (let i = 0; i < segments.length; i++) {
        updateNotPursuedCount(segments[i].runId, Math.round(Number(val.replace(/,/g, "")) / numSegments), true);
      }
      resetBudget(id);
    };

    const updateAllNotPursuedRatio = (val) => {
      for (let i = 0; i < segments.length; i++) {
        updateNotPursuedRatio(segments[i].runId, val, true);
      }
      resetBudget(id);
    };

    return (
      <div className={styles.realityColumn}>
        <div
          className={styles.realityColumnHeader}
          style={{
            backgroundColor: "rgb(126, 105, 215)",
            color: "#FFFF"
          }}
        >
          {`Overall`}
        </div>
        <div className={styles.realityInputSection}>
          <LineInput
            isMediumBox
            labelStyle={{ color: "#4B495B" }}
            value={pursued}
            onChange={(val) => updateAllPursuedCount(val.replace(/,/g, ""))}
            isDisabled={!applyOverall}
          />
        </div>
        <div className={styles.realityInputSection}>
          <LineInput
            isMediumBox
            labelStyle={{ color: "#4B495B" }}
            value={winRate}
            onChange={(val) => updateAllPursuedRatio(val)}
            isDisabled={!applyOverall}
          />
        </div>
        <div className={styles.realityInputSection}>
          <LineInput
            isMediumBox
            labelStyle={{ color: "#4B495B" }}
            value={notPursued}
            onChange={(val) => updateAllNotPursuedCount(val.replace(/,/g, ""))}
            isDisabled={!applyOverall}
          />
        </div>
        <div className={styles.realityInputSection}>
          <LineInput
            isMediumBox
            labelStyle={{ color: "#4B495B" }}
            value={notPursusedWinRate}
            onChange={(val) => updateAllNotPursuedRatio(val)}
            isDisabled={!applyOverall}
          />
        </div>
      </div>
    );
  };

  return (
    <React.Fragment>
      <div className={styles.realLabels} style={{ paddingBottom: "30px" }}>
        <div style={{ height: hasSplits ? "60px" : "30px" }}></div>
        <div className={styles.realityLabelDirectInput}>
          <div>
            {"How many"}
            <span className={styles.rBold}>{transactionLabel + " "}</span>
            <span>{" do you"}</span>
            <span className={styles.rBold}>{trueAction}</span>
            <span>{"?"}</span>
          </div>
        </div>
        <div className={styles.realityLabelDirectInput}>
          <div>
            For the <span className={styles.rBold}>{transactionLabel + " "}</span> you{" "}
            <span className={styles.rBold}>{trueAction}</span> what is your potential{" "}
            <span className={styles.rBold}>{outcomeLabel}</span> rate?
          </div>
        </div>
        <div className={styles.realityLabelDirectInput}>
          <div>
            {"How many"}
            <span className={styles.rBold}>{notPursuedTransactionLabel + " "}</span>
            <span>{" do you"}</span>
            <span className={styles.rBold}>{falseAction}</span>
            <span>{"?"}</span>
          </div>
        </div>
        <div className={styles.realityLabelDirectInput}>
          <div>
            The potential <span className={styles.rBold}>{trueAction}</span> rate for potential{" "}
            <span className={styles.rBold}>{transactionLabel + " "}</span> you{" "}
            <span className={styles.rBold}>{falseAction}</span>
          </div>
        </div>
      </div>
      {applyOverall && renderOverallControlColumn()}
      {renderRealityCheckColumns()}
      {!applyOverall && renderOverallControlColumn()}
    </React.Fragment>
  );
};

export default RealityCheckCard;
